import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { backupArray } from "../../../utils/backupArray";

export const createBackup = async (params: stdObject) => {
  const {
    t,
    setMsg,
    setModalData,
    setModalData2,
    searchValues,
    setSearchValues,
    closeMsg,
    logoutAction,
  } = params;
  setMsg("custom1");
  setModalData({
    code: "loading",
    title: t("p.dontCloseApp"),
    label: t("p.waitUntilProcessIsComplete"),
  });
  const responseBackup: stdObject = await sendData({
    endPoint: "createBackup",
    logoutAction,
  });
  const { success, status, backup } = responseBackup;
  if (success && status) {
    let tempSearch = searchValues;
    tempSearch.Z6.results = success && status ? backupArray(backup) : [];
    setSearchValues({ ...tempSearch });
    closeMsg();
  } else {
    setMsg("error");
    setModalData2({
      label: t("p.errorCreatingBackup"),
    });
  }
};
